import { z } from 'zod';

export const EngineAtomSearchSchema = z.object({
  lifecycleTab: z
    .enum(['all', 'draft', 'applied', 'archived'])
    .default('applied'),
  countryCode: z.string().default('all'),
  pageSize: z.number().default(50),
  pageIndex: z.number().default(0),
});

export type EngineAtomSearchParams = z.infer<typeof EngineAtomSearchSchema>;
